<div class="bp-page-header">
  <button pButton type="button" class="easymarine link back-button"
    icon="pi pi-arrow-left" label="Voltar" (click)="voltar()"></button>
  <div class="title-area">
    <h2><i [class]="headerIcon"></i> {{ headerTitle }}</h2>
    <p class="subtitle">
      Configure o escopo do processo. Você poderá voltar e editar até a confirmação final.
    </p>
  </div>
</div>

<div class="form-card">
  <h3 class="section-title">
    <i class="pi pi-info-circle"></i> Identificação
  </h3>
  <div class="field-grid">
    <div class="field" *ngIf="isMultiCompany">
      <label for="company">Empresa <span class="required">*</span></label>
      <p-dropdown id="company" [options]="marinaCompanyOptions"
        optionLabel="label" optionValue="value"
        [(ngModel)]="selectedCompanyKey" placeholder="Selecione a empresa"
        [showClear]="false" appendTo="body" styleClass="full-width"
        [disabled]="mode === 'edit'">
      </p-dropdown>
      <small *ngIf="mode === 'edit'" class="field-hint">Empresa não pode ser alterada após a criação.</small>
    </div>

    <div class="field field-wide">
      <label for="description">Descrição <span class="required">*</span></label>
      <input id="description" pInputText type="text" class="full-width"
        [(ngModel)]="description" (input)="onDescriptionInput()"
        maxlength="255" placeholder="Ex.: Faturamento Fevereiro/2026">
    </div>
  </div>

  <h3 class="section-title">
    <i class="pi pi-calendar"></i> Período de Referência
  </h3>
  <p class="section-help">
    Mês e ano que serão considerados na geração de mensalidades.
  </p>
  <div class="field-grid">
    <div class="field">
      <label for="ref-month">Mês <span class="required">*</span></label>
      <p-dropdown id="ref-month" [options]="monthOptions"
        optionLabel="label" optionValue="value"
        [(ngModel)]="referenceMonth" (onChange)="onPeriodChange()"
        appendTo="body" styleClass="full-width"
        [disabled]="mode === 'edit'">
      </p-dropdown>
    </div>
    <div class="field">
      <label for="ref-year">Ano <span class="required">*</span></label>
      <p-dropdown id="ref-year" [options]="yearOptions"
        optionLabel="label" optionValue="value"
        [(ngModel)]="referenceYear" (onChange)="onPeriodChange()"
        appendTo="body" styleClass="full-width"
        [disabled]="mode === 'edit'">
      </p-dropdown>
    </div>
  </div>
  <small *ngIf="mode === 'edit'" class="field-hint">
    Período de referência não pode ser alterado após a criação. Para isso, cancele este processo e crie um novo.
  </small>

  <div *ngIf="usesFranchise">
    <h3 class="section-title">
      <i class="pi pi-ticket"></i> Período de Referência da Franquia
    </h3>
    <p class="section-help">
      Esta marina utiliza o módulo de franquia. Informe o mês/ano que será considerado para
      contabilizar os consumos. Sugestão: o mês anterior ao mês da fatura.
    </p>
    <div class="field-grid">
      <div class="field">
        <label for="franchise-month">Mês franquia</label>
        <p-dropdown id="franchise-month" [options]="monthOptions"
          optionLabel="label" optionValue="value"
          [(ngModel)]="franchiseReferenceMonth"
          appendTo="body" styleClass="full-width">
        </p-dropdown>
      </div>
      <div class="field">
        <label for="franchise-year">Ano franquia</label>
        <p-dropdown id="franchise-year" [options]="yearOptions"
          optionLabel="label" optionValue="value"
          [(ngModel)]="franchiseReferenceYear"
          appendTo="body" styleClass="full-width">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-times" label="Cancelar" (click)="voltar()"
      [disabled]="saving"></button>
    <button pButton type="button" class="easymarine primary"
      icon="pi pi-check"
      [label]="mode === 'edit' ? 'Salvar alterações' : 'Criar processo'"
      [disabled]="!isValid() || saving" (click)="salvar()"></button>
  </div>
</div>
